import React, { FC, ReactNode } from 'react'
import { Button, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'

interface ICuratorInfoTip {
    /** What the tip is about, for the button's name: "About {about}". */
    about: string
    children: ReactNode
}

/** An info icon that explains what is beside it on hover or focus. A real button, so a keyboard can reach it. */
export const CuratorInfoTip: FC<ICuratorInfoTip> = ({ about, children }) => (
    <Tooltip title={children} trigger={['hover', 'focus']}>
        <Button
            type="text"
            size="small"
            shape="circle"
            aria-label={`About ${about}`}
            icon={<InfoCircleOutlined className="info-icon" />}
        />
    </Tooltip>
)
